import React, { useEffect, useState } from "react";

// JS Files

// Others File
import lamp from "../../imgs/lamp.svg";

const QuestionsCard = (props) => {
  return (
    <>
      <div className="bg-white rounded-lg p-4">
        <div className="flex items-centers">
          <img src={lamp} />
          <span className="mr-4 text-mygray-800">
           {props.header}
          </span>
        </div>
        <p
          className="text-sm leading-8 mt-4 mx-12 text-mygray-500"
        >
          {props.text}
        </p>
      </div>
    </>
  );
};
export default QuestionsCard;
